const common = {
  appLoading: "Đang tải ứng dụng...",
  turn_one: 'Kỳ',
  turn_other: 'Kỳ',
  contactSupport: 'Liên hệ hỗ trợ: {contactNumber}', // 1900234534
}

export default common;